module.exports = __webpack_public_path__ + "img/7.b68cc6ae.webp";